import ReactDOM from 'react-dom';
import { loadDOMComponent } from '../../helpers';
import { AppContextProvider } from '../../Services/AppContext';
import HealthData from './HealthData';

loadDOMComponent({
	selector: 'react-health-data',
	callback: ({ container, context, props }) => {
		const patientId = container.getAttribute('patientId');

		ReactDOM.render(
			<AppContextProvider {...context}>
				<HealthData patientId={patientId} />
			</AppContextProvider>,
			container,
		);
	},
});
